/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Submit_AnotherInputs */

const en_directory_submit_enrich_submit_another = /** @type {(inputs: Directory_Submit_Enrich_Submit_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit another tool`)
};

const zh_directory_submit_enrich_submit_another = /** @type {(inputs: Directory_Submit_Enrich_Submit_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再提交一个工具`)
};

/**
* | output |
* | --- |
* | "Submit another tool" |
*
* @param {Directory_Submit_Enrich_Submit_AnotherInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_submit_another = /** @type {((inputs?: Directory_Submit_Enrich_Submit_AnotherInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Submit_AnotherInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_submit_another(inputs)
	return zh_directory_submit_enrich_submit_another(inputs)
});
export { directory_submit_enrich_submit_another as "directory.submit.enrich.submit_another" }